import { nanoid } from 'nanoid';
import { syncAction } from 'lib/action';

export const completeAction = syncAction('@router/COMPLETE');
export const noLocationChange = syncAction('@router/noLocationChange');
export const completeResetAction = syncAction('@router/COMPLETE_RESET', () => ({ payload: nanoid(8) }));
export const completeEmptyAction = syncAction('@router/COMPLETE_EMPTY', () => ({ payload: nanoid(8) }));
export const updateQueryAction = syncAction<Record<string, string | string[] | number | boolean | null | undefined>>(
  '@router/UPDATE_QUERY',
);
export const redirectAction = syncAction('@router/REDIRECT');
